import React from 'react';

import {
  ALIQUOTS_NUMBER,
  ALIQUOTS_VOLUME,
  EIGHTY_PERCENT,
  HUNDERED_PERCENT,
  NORMALIZATION,
  NORMALIZATION_OPTIONS,
  VOLUME,
} from 'src/constants/forms';
import { Message } from 'src/core/components';
import { getVolumeMaxValue } from '../Normalization/components/validators';

export const maxNumberValidatorAliquots = (
  maxNumber,
  aliquot,
  errorMessage = {}
) => ({
  validator: (value) => parseInt(value, 10) * parseInt(aliquot, 10) <= maxNumber ?
    'success' :
    'error',
  errorMessage: (
    <Message
      message={{
        ...errorMessage,
        values: { value: maxNumber },
      }}
    />
  ),
});

export const aliquotsMaxValueValidator = (
  formData,
  fieldName,
  value,
  setMaxValue,
  plateSizeDetails = {}
) => {
  const maxValue = formData[NORMALIZATION]?.value === NORMALIZATION_OPTIONS.CONCENTRATION ?
    getVolumeMaxValue(plateSizeDetails?.plateSize?.value, plateSizeDetails?.wellVolume?.value) :
    ((parseInt(formData[VOLUME]?.value, 10) / HUNDERED_PERCENT) * EIGHTY_PERCENT);

  setMaxValue(maxValue);

  if (fieldName === ALIQUOTS_NUMBER) {
    return formData[ALIQUOTS_VOLUME]?.value * value > maxValue;
  }

  return formData[ALIQUOTS_NUMBER]?.value * value > maxValue;
};
